import { render, staticRenderFns } from "./AccountLegalDocuments.vue?vue&type=template&id=4fcc2a28&scoped=true"
import script from "./AccountLegalDocuments.vue?vue&type=script&lang=js"
export * from "./AccountLegalDocuments.vue?vue&type=script&lang=js"
import style0 from "./AccountLegalDocuments.vue?vue&type=style&index=0&id=4fcc2a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcc2a28",
  null
  
)

export default component.exports